import { mode } from '@chakra-ui/theme-tools'
import { clr } from './foundations/colors'

export const globalStyles = {
  fontWeights: {
    light: 300,
    normal: 400,
    bold: 700,
    black: 900
  },
  fontSizes: {
    '2xs': '10px'
  },
  lineHeights: {
    normal: 'normal',
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: '2',
    '3': '.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem'
  },
  letterSpacings: {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em'
  },
  space: {
    px: '1px',
    0.5: '0.125rem',
    1: '0.25rem',
    1.5: '0.375rem',
    2: '0.5rem',
    2.5: '0.625rem',
    3: '0.75rem',
    3.5: '0.875rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    28: '7rem',
    32: '8rem',
    36: '9rem',
    40: '10rem',
    44: '11rem',
    48: '12rem',
    52: '13rem',
    56: '14rem',
    60: '15rem',
    64: '16rem',
    72: '18rem',
    80: '20rem',
    96: '24rem'
  },
  styles: {
    global: props => ({
      '*': {
        borderColor: 'var(--border)'
      },
      body: {
        bg: 'var(--back)',
        // backgroundImage: 'linear-gradient(45deg, var(--front) 0%, var(--back) 100%)',
        color: 'var(--text)',
        fontFamily: 'Lato, sans-serif'
      },
      html: {
        fontFamily: 'Lato, sans-serif'
      },
      ':root': {
        // accent
        '--main': mode(clr.light.main, clr.dark.main)(props),
        '--logo': mode(clr.light.logo, clr.dark.logo)(props),

        // txt
        '--heading': mode(clr.light.heading, clr.dark.heading)(props),
        '--text': mode(clr.light.text, clr.dark.text)(props),
        '--text-alt': mode(clr.light['text-alt'], clr.dark['text-alt'])(props),
        '--muted': mode(clr.light.muted, clr.dark.muted)(props),
        '--link': mode(clr.light.link, clr.dark.link)(props),
        '--nav': mode(clr.light.nav, clr.dark.nav)(props),
        '--link-alt': mode(clr.light['link-alt'], clr.dark['link-alt'])(props),

        // bg
        '--front': mode(clr.light.front, clr.dark.front)(props),
        '--back': mode(clr.light.back, clr.dark.back)(props),
        '--hover': mode(clr.light.hover, clr.dark.hover)(props),
        '--row': mode(clr.light.row, clr.dark.row)(props),
        '--progress': mode(clr.light.progress, clr.dark.progress)(props),
        '--mark': mode(clr.light.mark, clr.dark.mark)(props),
        '--loader': mode(clr.light.loader, clr.dark.loader)(props),

        // border
        '--border': mode(clr.light.border, clr.dark.border)(props),
        '--input-border': mode(clr.light['input-border'], clr.dark['input-border'])(props),

        // btn
        '--btn': mode(clr.light['btn'], clr.dark['btn'])(props),
        '--btn-alt': mode(clr.light['btn-alt'], clr.dark['btn-alt'])(props),
        '--error': mode(clr.light['error'], clr.dark['error'])(props),
        '--error-alt': mode(clr.light['error-alt'], clr.dark['error-alt'])(props),
        '--success': mode(clr.light['success'], clr.dark['success'])(props),
        '--success-alt': mode(clr.light['success-alt'], clr.dark['success-alt'])(props),
        '--warning': mode(clr.light['warning'], clr.dark['warning'])(props),
        '--warning-alt': mode(clr.light['warning-alt'], clr.dark['warning-alt'])(props),
        '--ghost': mode(clr.light.ghost, clr.dark.ghost)(props),

        // scroll
        '--thumb': mode(clr.light.thumb, clr.dark.thumb)(props),
        '--thumb-hover': mode(clr.light['thumb-hover'], clr.dark['thumb-hover'])(props),
        '--track': mode(clr.light.track, clr.dark.track)(props),

        '--border-radius': '3px'
      }
    })
  }
}
